export default "__VITE_ASSET__CHP5a0Wo__"